export default __webpack_public_path__ + "static/form-grouping-dont-902e4414b49da7aa513d22dcffe6777d.png";